/** Where a viewer came from: utm_source, else the embedding or linking site, else direct. */
export function getLoadSource(href = window.location.href, referrer = document.referrer): string {
  const utmSource = new URL(href).searchParams.get('utm_source');
  if (utmSource) {
    return utmSource
      .toLowerCase()
      .replace(/[^a-z0-9.-]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 100);
  }
  if (!referrer) return 'direct';
  try {
    return new URL(referrer).hostname.replace(/^www\./, '');
  } catch {
    return 'direct';
  }
}
